<template>
	<section>
		<buy_form :user="user" :library_link="library_link" :request_id="request_id" :charge_amount="24" :charge_amount_disabled="true" :api_prefix="api_prefix" @payment_processed="payment_processed"></buy_form>
	</section>
</template>

<script>
import BuyForm from "@/components/BuyForm.vue";

export default {
	props: ['user','subscription_plan','api_prefix'],
    data() {
        return {
		  request_id: null,
		  show_link: false,
		}
	},
	computed: {
      library_link: function ()
      {
		if(this.show_link==true)
		{
        	return "/library/" + this.request_id
		}
		else
		{
			return null
		}
      }
    },
	mounted: function() 
    {
        window.analytics.page('Buy');
		let self = this;
		var request_id = this.$route.params.request_id;
		if (request_id!=null)
		{
			self.request_id = request_id
		}
	},
	components: {
      'buy_form': BuyForm,
    },
	methods: {
		payment_processed(url, request_id)
		{
			//display the new video without the watermark
			this.show_link = true
		},
	}
}
</script>

<style scoped>

</style>
